import React, { useState, useEffect } from 'react';
import './App.css';
import Chat from './components/Chat';
import ResetPasswordForm from './components/auth/ResetPasswordForm';
import AccountActivation from './components/AccountActivation';
import SetPasswordPage from './components/auth/SetPasswordPage';

function App() {
  const [currentPath, setCurrentPath] = useState('/');
  
  // Simple routing based on URL hash
  useEffect(() => {
    // Get path from hash or use pathname as fallback
    const getPath = () => {
      // If we have a hash, use it (remove the # symbol)
      if (window.location.hash) {
        return window.location.hash.substring(1);
      }
      // Otherwise use the pathname
      return window.location.pathname;
    };
    
    // Set initial path
    setCurrentPath(getPath());
    
    // Listen for hash changes
    const handleHashChange = () => {
      setCurrentPath(getPath());
    };
    
    // Listen for both hash changes and popstate
    window.addEventListener('hashchange', handleHashChange);
    window.addEventListener('popstate', handleHashChange);
    
    // If there's no hash but there's a pathname, convert it to hash
    if (!window.location.hash && window.location.pathname !== '/') {
      window.location.hash = '#' + window.location.pathname;
    }
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
      window.removeEventListener('popstate', handleHashChange);
    };
  }, []);
  
  // Render component based on path
  const renderComponent = () => {
    if (currentPath === '/reset-password') {
      return <ResetPasswordForm 
        onSuccess={() => window.location.hash = '#/login'} 
        onCancel={() => window.location.hash = '#/login'} 
      />;
    }
    
    // Handle account activation route
    if (currentPath.startsWith('/activate/')) {
      const token = currentPath.replace('/activate/', '');
      return <AccountActivation token={token} />;
    } else if (currentPath === '/activate') {
      return <AccountActivation />;
    }
    
    // Handle set password route
    if (currentPath.startsWith('/set-password/')) {
      const token = currentPath.replace('/set-password/', '');
      return <SetPasswordPage token={token} />;
    } else if (currentPath === '/set-password') {
      return <SetPasswordPage />;
    }
    
    // Default to Chat component
    return <Chat />;
  };
  
  return (
    <div className="App">
      {renderComponent()}
    </div>
  );
}

export default App;
